import {initPromoStaticpromo} from "./init";
import { onMount } from '@otto-ec/global-resources/dom';

onMount(".promo_staticpromo-container", () => {
    initPromoStaticpromo()
});